import { Package, CookingPot, ArrowFatLineUp, PencilSimple } from "@phosphor-icons/react";
import { StockBadge, MinCell, StockInForm, AdjustStockForm } from "./widgets";

export const FinishedGoodsPanel = ({ products, isAdmin, adjustFor, setAdjustFor, stockInFor, setStockInFor, adjustStock, stockIn, setMin, setRecipeFor }) => (
  <div className="rounded-md border border-slate-200 bg-white" data-testid="finished-goods-panel">
    <div className="flex items-center justify-between border-b border-slate-200 p-4">
      <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
        <Package size={18} weight="duotone" /> Finished Goods
      </h2>
      <span className="text-xs text-slate-400">{products.length} products</span>
    </div>
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
          <th className="p-3">Product</th>
          <th className="p-3 text-right">Stock</th>
          {isAdmin && <th className="p-3 text-right">Min</th>}
          {isAdmin && <th className="p-3">Recipe</th>}
          <th className="p-3 text-right">Stock In</th>
        </tr>
      </thead>
      <tbody data-testid="finished-goods-table-body">
        {products.length === 0 && (
          <tr><td colSpan={isAdmin ? 5 : 3} className="p-5 text-center text-slate-400">No products yet. Add them from the Masters page.</td></tr>
        )}
        {products.map((p) => (
          <tr key={p.id} className="border-b border-slate-100 align-top hover:bg-slate-50">
            <td className="p-3 font-medium">{p.name}</td>
            <td className="p-3 text-right">
              {adjustFor === p.id ? (
                <AdjustStockForm current={p.stock} testId={`product-adjust-${p.name}`}
                  onSubmit={(v, n) => adjustStock("product", p.id, v, n)} onCancel={() => setAdjustFor(null)} />
              ) : (
                <span className="inline-flex items-center gap-1.5">
                  <StockBadge stock={p.stock} min={p.min_stock} testId={`product-stock-${p.name}`} />
                  {isAdmin && (
                    <button onClick={() => setAdjustFor(p.id)} data-testid={`product-adjust-button-${p.name}`}
                      title="Correct this stock value"
                      className="p-0.5 text-slate-400 transition-colors duration-150 hover:text-slate-700">
                      <PencilSimple size={13} weight="duotone" />
                    </button>
                  )}
                </span>
              )}
            </td>
            {isAdmin && (
              <td className="p-3 text-right">
                <MinCell value={p.min_stock} testId={`product-min-${p.name}`}
                  onSave={(v) => setMin("product", p.id, v)} />
              </td>
            )}
            {isAdmin && (
              <td className="p-3">
                <button onClick={() => setRecipeFor(p)} data-testid={`recipe-button-${p.name}`}
                  className="flex items-center gap-1 rounded-md border border-slate-300 px-2 py-1 text-xs text-slate-600 hover:bg-slate-100">
                  <CookingPot size={13} /> {p.recipe.length ? `${p.recipe.length} item(s)` : "Set recipe"}
                </button>
              </td>
            )}
            <td className="p-3 text-right">
              {stockInFor === `product-${p.id}` ? (
                <StockInForm testId={`product-stockin-${p.name}`}
                  onSubmit={(q, n) => stockIn("product", p.id, q, n)} onCancel={() => setStockInFor(null)} />
              ) : (
                <button onClick={() => setStockInFor(`product-${p.id}`)} data-testid={`product-stockin-button-${p.name}`}
                  className="inline-flex items-center gap-1 rounded-md bg-slate-900 px-2.5 py-1 text-xs font-semibold text-white hover:bg-slate-700">
                  <ArrowFatLineUp size={12} weight="bold" /> Stock In
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
